import { appMessages as messages } from '../../../../../messages'
import { WORKOUT_KEY } from '../../../../../modules/workout/model/constants/key'

import createValidationElementUtil from '../../../../redux/utils/create-validation-element'

const MIN_CALORIES = 0
const MAX_CALORIES = 5000

function caloriesWorkoutValidatorUtil (value) {
  if (typeof value === 'string') {
    value = parseInt(value, 10)
  }
  if (Number.isNaN(value)) {
    return createValidationElementUtil(WORKOUT_KEY.CALORIES, messages.invalid, {
      name: 'Calories'
    })
  }
  if (value < MIN_CALORIES) {
    return createValidationElementUtil(WORKOUT_KEY.CALORIES, messages.minimum, {
      key: WORKOUT_KEY.CALORIES,
      min: MIN_CALORIES
    })
  }
  if (value > MAX_CALORIES) {
    return createValidationElementUtil(WORKOUT_KEY.CALORIES, messages.maximum, {
      key: WORKOUT_KEY.CALORIES,
      max: MAX_CALORIES
    })
  }
}

export { caloriesWorkoutValidatorUtil }
